export default __webpack_public_path__ + "static/Lutfhi Zarkasyi-91397c1fb83196b9a958069245252b27.webp";